import type { ParticipantRole } from './types'
import { USE_MOCK_API } from './httpClient'
import { getInviteLinkMock, createInviteLinkMock, revokeInviteLinkMock, joinTripMock } from './invite.mock'
import { getInviteLinkHttp, createInviteLinkHttpImpl, revokeInviteLinkHttp, joinTripHttp } from './invite.http'

export interface InviteLink {
  token: string
  role: ParticipantRole | 'contributor' | 'guest'
  max_uses: number
  expires_at: string | null
}

export function getInviteLink(tripId: string): Promise<InviteLink | null> {
  return USE_MOCK_API ? getInviteLinkMock(tripId) : getInviteLinkHttp(tripId)
}

export function createInviteLink(
  tripId: string,
  role?: string,
  maxUses?: number,
  expiresAt?: string,
): Promise<InviteLink> {
  return USE_MOCK_API
    ? createInviteLinkMock(tripId, role, maxUses, expiresAt)
    : createInviteLinkHttpImpl(tripId, role, maxUses, expiresAt)
}

export function revokeInviteLink(tripId: string): Promise<void> {
  return USE_MOCK_API ? revokeInviteLinkMock(tripId) : revokeInviteLinkHttp(tripId)
}

export function joinTrip(token: string): Promise<{ trip_id: string; role: string }> {
  return USE_MOCK_API ? joinTripMock(token) : joinTripHttp(token)
}
